import { Col } from "reactstrap";
import { LabelText } from "../Utils/Input";
import InputField from "../Utils/InputField";
import MapWithSearch from "../GoogleMap/MapWithSearch";

export default function FormLine3({
  touched,
  errors,
  handleChange,
  handleBlur,
  values,
  setFieldValue,
  isCreate,
}) {
  return (
    <>
      {/* {!isCreate ? (
      <MapWithSearch setFieldValue={setFieldValue} values={values} />
    ) : null} */}
      {/* <MapWithSearch setFieldValue={setFieldValue} values={values} /> */}
      <Col xxl={3} md={6}>

        <LabelText htmlFor={"coordinates.latitude"} displayText={"Latitude"} className={"text-danger"} />
        <LabelText
          htmlFor={"coordinates.latitude"}
          classLabelName={`d-block ms-0 rv-sub-label ${touched?.coordinates?.latitude && errors?.coordinates?.latitude
              ? "rv-label-danger"
              : "rv-label-muted"
            } `}

          displayText={
            touched?.coordinates?.latitude && errors?.coordinates?.latitude
              ? errors?.coordinates?.latitude
              : "Enter Latitude "
          }

        />
        <InputField
          name={"coordinates.latitude"}
          type={"text"}
          className={"form-control"}
          id={"coordinates.latitude"}
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={values.coordinates.latitude || ""}
          invalid={touched?.coordinates?.latitude && errors?.coordinates?.latitude ? true : false}
        />
      </Col>
      <Col xxl={3} md={6}>
        <LabelText
          htmlFor={"coordinates.longitude"}
          displayText={"Longitude"}
          className={"text-danger"}
        />
        <LabelText
          htmlFor={"coordinates.longitude"}
          classLabelName={`d-block ms-0 rv-sub-label ${touched.coordinates?.longitude && errors.coordinates?.longitude
              ? "rv-label-danger"
              : "rv-label-muted"
            } `}
          displayText={
            touched.coordinates?.longitude && errors.coordinates?.longitude
              ? errors.coordinates?.longitude
              : "Enter Longitude"
          }
        />
        <InputField
          name={"coordinates.longitude"}
          type={"text"}
          className={"form-control"}
          id={"coordinates.longitude"}
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={values.coordinates?.longitude || ""}
          invalid={touched?.coordinates?.longitude && errors?.coordinates?.longitude ? true : false}

        />
      </Col>

      {/* <Col xxl={3} md={6}>
        <LabelText htmlFor={"modem.iccid"} displayText={"ICCID"} />
        <LabelText
          htmlFor={"modem.iccid"}
          classLabelName={`d-block ms-0 rv-sub-label ${touched.iccid && errors.iccid ? "rv-label-danger" : "rv-label-muted"
            } `}
          displayText={
            touched.iccid && errors.iccid ? errors.iccid : "Enter ICCID"
          }
        />
        <InputField
          name={"modem.iccid"}
          type={"text"}
          className={"form-control"}
          id={"modem.iccid"}
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={values.modem?.iccid || ""}
        />
      </Col>

      <Col xxl={3} md={6}>
        <LabelText htmlFor={"modem.imsi"} displayText={"IMSI"} />
        <LabelText
          htmlFor={"modem.imsi"}
          classLabelName={`d-block ms-0 rv-sub-label ${touched.imsi && errors.imsi ? "rv-label-danger" : "rv-label-muted"
            } `}
          displayText={touched.imsi && errors.imsi ? errors.imsi : "Enter IMSI"}
        />
        <InputField
          name={"modem.imsi"}
          type={"text"}
          className={"form-control"}
          id={"modem.imsi"}
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={values.modem?.imsi || ""}
        />
      </Col> */}
    </>
  );
}
